module.exports = __webpack_public_path__ + "img/7.4213d834.png";